<div class="row">
    <div class="col-12 col-md-6">
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Unknown Payment Management</h2>
                <div class="page-section-actions">
                    <a class="btn btn-sm btn-outline-light" [routerLink]="['/lo', company_uuid, 'unknown-payment', 'form']">+ Add Unknown Payment</a>
                </div>
            </div>
            <div class="page-section-body">
                <app-table #table></app-table>
            </div>
        </div>
    </div>
</div>
